import { Avatar } from 'antd';
import { GroupProps } from 'antd/es/avatar';
import React from 'react';
import { SonarUser } from '@ui/SonarUser';

export interface UserAvatarGroupProps extends GroupProps {
	large?: boolean;
	userIds: number[];
}

export const UserAvatarGroup: React.FC<UserAvatarGroupProps> = ({ large, userIds, ...rest }) =>
	<Avatar.Group { ...rest }>
		{ userIds.map((id) =>
			<SonarUser
				key={ id }
				large={ large }
				showTooltip
				userId={ id }
				withFullName={ false } />) }
	</Avatar.Group>;

